import {
	TRIGGER_VALIDATE_VPA_API_CALL,
	TRIGGER_VALIDATE_VPA_API_CALL_SUCCESS,
	TRIGGER_CLEAR_MERCHANT_INFO_DETAILS,
} from 'redux/actionTypes';

export function triggerValidateVpaApiCall(data, callback, stopLoader) {
	return {
		type: TRIGGER_VALIDATE_VPA_API_CALL,
		data,
		stopLoader,
		callback,
	};
}

export function triggerValidateVpaApiCallSuccess(data) {
	return {
		type: TRIGGER_VALIDATE_VPA_API_CALL_SUCCESS,
		data,
	};
}

export function triggerClearMerchantInfoDetails(data) {
	return {
		type: TRIGGER_CLEAR_MERCHANT_INFO_DETAILS,
		data,
	};
}
